import PropTypes from 'prop-types';
import clsx from 'clsx';
import classes from './Textarea.module.css';

const Textarea = ({
  className,
  setter = () => {},
  label,
  placeholder,
  parentStyles = {},
  value,
  customStyles = {},
  errorText = '',
  isOptional = false,
  rows = 10,
  ...rest
}) => {
  return (
    <div
      className={clsx(classes.wrapper, className, {
        [classes.error]: errorText
      })}
      style={parentStyles}>
      {label && (
        <label htmlFor="" className={classes.labelText}>
          {label} {!isOptional && <span className={'steric'}>*</span>}
        </label>
      )}
      <div className={classes.container}>
        <textarea
          rows={rows}
          placeholder={placeholder}
          value={value}
          style={customStyles}
          className={clsx(classes.textarea, { [classes.error]: !!errorText })}
          onChange={(e) => setter(e.target.value)}
          {...rest}
        />
      </div>
      {errorText && <p className={clsx('mt-2', classes.errorText)}>{errorText}</p>}
    </div>
  );
};

// Define PropTypes for the component
Textarea.propTypes = {
  className: PropTypes.string,
  setter: PropTypes.func.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  parentStyles: PropTypes.object,
  customStyles: PropTypes.object,
  errorText: PropTypes.string,
  isOptional: PropTypes.bool
};

// Define default props
Textarea.defaultProps = {
  className: '',
  label: '',
  placeholder: 'Enter text...',
  parentStyles: {},
  customStyles: {},
  errorText: '',
  isOptional: false
};

export default Textarea;
